import {HTMLAttributes, MouseEventHandler} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Dot} from '../../atoms/Dot/Dot';
import {Text} from '../../atoms/Text/Text';

interface BelowTabSelectLabelProps extends HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
  hasDot?: boolean;
  onClick?: MouseEventHandler;
}

export function BelowTabSelectLabel({
  children,
  isActive,
  hasDot,
  onClick,
  className,
  ...props
}: BelowTabSelectLabelProps) {
  return (
    <div
      className={twMerge(
        'font-small2 flex items-center justify-center py-11pxr',
        className
      )}
      {...props}
    >
      <div className="relative flex max-w-full">
        <Text
          className={twMerge(
            'inline-block cursor-pointer select-none overflow-hidden text-ellipsis whitespace-pre text-left text-theme-solid-60',
            isActive && 'font-small2-bold text-theme-solid-100'
          )}
          onClick={onClick}
        >
          {children}
        </Text>
        {hasDot && <Dot className="absolute -top-4pxr -right-4pxr" />}
      </div>
    </div>
  );
}

export const BelowTabSelectLabelType = (<BelowTabSelectLabel />).type;
